export default __webpack_public_path__ + "a43e453b8d2e240e49c963000f719b41.png";